var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title-component" }, [
    _vm.computedTitle === "Organize my funeral"
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col title title-first-letter" }, [
            _c("h1", [_vm._v(_vm._s(_vm.computedTitle))])
          ])
        ])
      : _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col title" }, [
            _c("h1", [_vm._v(_vm._s(_vm.computedTitle))])
          ])
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "row description" }, [
      _c("div", { staticClass: "col" }, [
        _c("h3", [_vm._v(_vm._s(_vm.computedDescription))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e6275a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e6275a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TitleComponent.vue
// module id = null
// module chunks = 